const CalendarIcon = ({ fill = '#171717' }: { fill?: string }) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.375 11.375H12.5V9.625H10.25C9.35254 9.625 8.625 10.3525 8.625 11.25V20.75C8.625 21.6475 9.35254 22.375 10.25 22.375H21.75C22.6475 22.375 23.375 21.6475 23.375 20.75V11.25C23.375 10.3525 22.6475 9.625 21.75 9.625H19.5V11.375H21.625V20.625H10.375V11.375ZM17 11.375H15V9.625H17V11.375Z"
      fill={fill}
    />
    <path d="M12.5 14.5H13.5V15.5H12.5V14.5Z" stroke={fill} />
    <path d="M18.5 14.5H19.5V15.5H18.5V14.5Z" stroke={fill} />
    <path d="M15.5 14.5H16.5V15.5H15.5V14.5Z" stroke={fill} />
    <path d="M13.6499 9.5H13.8999V11.5H13.6499L13.6499 9.5Z" stroke={fill} />
    <path d="M18.1499 9.5H18.3999V11.5H18.1499L18.1499 9.5Z" stroke={fill} />
    <path d="M12.5 17.5H13.5V18.5H12.5V17.5Z" stroke={fill} />
    <path d="M15.5 17.5H16.5V18.5H15.5V17.5Z" stroke={fill} />
    <path d="M18.5 17.5H19.5V18.5H18.5V17.5Z" stroke={fill} />
  </svg>
);

export default CalendarIcon;
